import { getArtifactBlockFormatter } from './artifact-block/registry';
import { jsx as _jsx } from "react/jsx-runtime";
export function ArtifactBlock({
  block,
  onArtifactClick,
  disableArtifacts
}) {
  const artifactBlock = block;
  const Formatter = getArtifactBlockFormatter(artifactBlock.artifactType);
  return /*#__PURE__*/_jsx(Formatter, {
    block: artifactBlock,
    onArtifactClick: onArtifactClick,
    disableArtifacts: disableArtifacts
  });
}